// Helper to open Google Maps with directions from the user's current location to the
// mariachi's real address (BRAND.address, kept in data/content.js).
// Uses the browser's Geolocation API. Falls back to destination-only if permission denied or unsupported.

import { LOCATION } from "../data/content";

// Coordenadas exactas en vez de la dirección en texto: más preciso para trazar
// la ruta (la dirección de barrio/manzana no siempre geocodifica bien sola).
const DESTINATION_ADDRESS = `${LOCATION.lat},${LOCATION.lng}`;

const buildUrl = (origin) => {
    const base = "https://www.google.com/maps/dir/?api=1";
    const destination = `&destination=${encodeURIComponent(DESTINATION_ADDRESS)}`;
    const travel = "&travelmode=driving";
    const org = origin ? `&origin=${origin}` : "";
    return `${base}${org}${destination}${travel}`;
};

const openInNewTab = (url) => {
    const w = window.open(url, "_blank", "noopener,noreferrer");
    if (!w) {
        // popup blocked — fall back to same-tab navigation
        window.location.href = url;
    }
};

export const openDirections = () => {
    const fallbackUrl = buildUrl(null);

    if (!("geolocation" in navigator)) {
        openInNewTab(fallbackUrl);
        return;
    }

    // Try to get user location with a 6s timeout, but open fallback immediately if user denies.
    let opened = false;
    const timer = setTimeout(() => {
        if (opened) return;
        opened = true;
        openInNewTab(fallbackUrl);
    }, 6000);

    navigator.geolocation.getCurrentPosition(
        (pos) => {
            if (opened) return;
            opened = true;
            clearTimeout(timer);
            const origin = `${pos.coords.latitude},${pos.coords.longitude}`;
            openInNewTab(buildUrl(origin));
        },
        () => {
            if (opened) return;
            opened = true;
            clearTimeout(timer);
            openInNewTab(fallbackUrl);
        },
        { enableHighAccuracy: false, timeout: 5000, maximumAge: 300000 }
    );
};

export const DIRECTIONS_FALLBACK_URL = buildUrl(null);
